import { action, makeObservable, observable } from 'mobx';

export class MultichoiceManager {
  constructor() {
    makeObservable(this);
  }

  @observable multichoiceItems = new Map();

  @action setMultichoiceItems(id, items) {
    this.multichoiceItems.set(id, items);
  }

  @action getMultichoiceItems(id) {
    return this.multichoiceItems.get(id);
  }

  @action hasMultichoiceItems(id) {
    return this.multichoiceItems.has(id);
  }

  @action clearMultichoiceItems() {
    this.multichoiceItems.clear();
  }

  /**
   * Preserve cached answer order (e.g. randomization) while refreshing text
   * from the current (possibly translated) model answers.
   */
  @action syncMultichoiceItemTexts(id, modelAnswers) {
    if (!this.multichoiceItems.has(id) || !modelAnswers?.length) {
      return;
    }
    const cached = this.multichoiceItems.get(id) || [];
    const textById = new Map(modelAnswers.map((answer) => [answer.id, answer.text]));
    let changed = false;
    const synced = cached.map((answer) => {
      if (!textById.has(answer.id) || textById.get(answer.id) === answer.text) {
        return answer;
      }
      changed = true;
      return { ...answer, text: textById.get(answer.id) };
    });
    if (changed) {
      this.multichoiceItems.set(id, synced);
    }
  }
}

export default new MultichoiceManager();
